import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import ProtectedRoute from "./components/ProtectedRoute";
import JourneyTracker from "./components/JourneyTracker";
import PanelLayout from "./components/PanelLayout";
import Login from "./components/Login";
import ForgotPassword from "./pages/ForgotPassword";
import InventoryPage from "./pages/inventory/InventoryPage";
import RecentPage from "./pages/recent/RecentPage";
import UsersPage from "./pages/users/UsersPage";
import PlansPage from "./pages/plans/PlansPage";
import PlanPage from "./pages/plans/PlanPage";
import { PlansProvider } from "./plans/PlansContext";
import { AuthProvider, SUPERADMIN } from "./contexts/AuthContext";
import { InventoryProvider } from "./inventory/InventoryContext";

function App() {
  return (
    <AuthProvider>
      <Router>
        <JourneyTracker />
        <Routes>
          {/* Public: no panel chrome */}
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />

          {/* Panel: top bar and sidebar around every signed-in page */}
          <Route
            element={
              <ProtectedRoute>
                <InventoryProvider>
                  <PlansProvider>
                    <PanelLayout />
                  </PlansProvider>
                </InventoryProvider>
              </ProtectedRoute>
            }
          >
            <Route path="/inventory" element={<InventoryPage />} />
            <Route path="/plans" element={<PlansPage />} />
            <Route path="/plans/:id" element={<PlanPage />} />
            <Route
              path="/recent"
              element={
                <ProtectedRoute allowedRoles={[SUPERADMIN]}>
                  <RecentPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/users"
              element={
                <ProtectedRoute allowedRoles={[SUPERADMIN]}>
                  <UsersPage />
                </ProtectedRoute>
              }
            />
          </Route>

          <Route path="*" element={<Navigate to="/inventory" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
